<template>
    <div class="ProfileData">
        <div class="nav_box box-shadow">
            <el-menu :default-active='activeIndex' mode="horizontal" class="el-menu-demo">
                <el-menu-item index="1" @click="profileData">数据概况</el-menu-item>
                <el-menu-item index="2" @click="traffic">流量分析</el-menu-item>
                <el-menu-item index="3" @click="trading">交易分析</el-menu-item>
                <el-menu-item index="4" @click="content">内容分析</el-menu-item>
                <el-menu-item index="5" @click="user">用户分析</el-menu-item>
            </el-menu>
        </div>
        <div class="container_wrap1 padding-15 bgc box-shadow">
            <div class="title_box">
                <p>实时数据</p>
                <!-- <p><img :src="icon" alt="">实时数据</p> -->
            </div>
            <div class="content_wrap1">
                <div class="content_left_box">
                    <div class="top_box">
                        <p>
                            <span>付款金额</span>&nbsp;
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">0点截至当前时间，所有付款订单金额之和（拼团在成团时计入统计，问答在回答后计入统计，API导入订单不计入统计）</div>
                                <img class="tooltip_icon" :src="toolTipsIcon" alt="">
                            </el-tooltip>
                        </p>
                        <div>
                            <div>
                                <p>付款金额(元)</p>
                                <p>{{todayallmoney}}</p>
                            </div>
                            <div>
                                <p>昨日全天(元)</p>
                                <p>{{yesterdayallmoney}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="echarts_box">
                        <Echarts1 :incomeDatas="incomeDatas"></Echarts1>
                    </div>
                </div>
                <div class="content_right_box">
                    <div class="item_box" v-for="(item, index) of realTimeData" :key="index">
                        <p>
                            <span>{{item.title}}</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">{{item.tips}}</div>
                                <img class="tooltip_icon" :src="item.toolTipIcon" alt="">
                            </el-tooltip>
                        </p>
                        <p>{{item.access}}</p>
                        <p>昨日全天&nbsp;&nbsp;{{item.num}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container_wrap2">
            <div class="search_box">
                <div class="title_text">运营视窗</div>
                <div class="select_box">
                    <div style="width: 120px;">
                        <el-select v-model="dayValue" placeholder="自然天">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <el-date-picker :clearable="false" v-model="dateValue" align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                    <el-button type="primary" plain @click="searchClick">搜索</el-button>
                </div>
            </div>
            <div class="content_wrap2 padding-15 bgc box-shadow">
                <div class="title_box">
                    <p>核心指标</p>
                </div>
                <div class="choose_content_wrap2">
                    <div class="choose_list">
                        <div class='choose_list_item' v-for="(item, index) in coreIndexData" :key="index">
                            <p>
                                <span>{{item.title}}</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">{{item.tips}}</div>
                                    <img class="tooltip_icon" :src="toolTipsIcon" alt="">
                                </el-tooltip>
                            </p>
                            <p>{{item.data}}</p>
                            <p>日环比 {{item.day}}</p>
                            <p>周同比 {{item.week}}</p>
                        </div>
                    </div>
                </div>
                <div class="echarts_wrap2">
                    <Echarts2 :coreData="coreData"></Echarts2>
                </div>
            </div>
        </div>
        <div class="container_wrap3 padding-15 bgc box-shadow">
            <div class="title_box">
                <p>流量看板</p>
                <p @click="pageJump('Traffic')"><img :src="icon" alt="">流量分析</p>
            </div>
            <div class="content_wrap3">
                <div class="echarts3">
                    <Echarts3 :trafficEchartsData="trafficEchartsData"></Echarts3>
                </div>
                <div class="content_right_box">
                    <div class='item_box' v-for="(item, index) in trafficData" :key="index">
                        <p>
                            <span>{{item.title}}</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">{{item.tips}}</div>
                                <img class="tooltip_icon" :src="toolTipsIcon" alt="">
                            </el-tooltip>
                        </p>
                        <p>{{item.conentviewsum}}</p>
                        <p>日环比 {{item.day}}&emsp; 周同比 {{item.week}}</p>
                    </div>
                </div>
            </div>
            <div class="title_box">
                <p>转化看板</p>
                <p @click="pageJump('Trading')"><img :src="icon" alt="">交易分析</p>
            </div>
            <div class="content_traffic_wrap3">
                <div class="order_rate_box" v-for="(item, index) in convertData" :key="index">
                    <div>
                        <div>
                            <div>
                                <p>{{item.title}}</p>
                                <p>{{index === 0 ? item.visitororderconversionRate : item.visitorpayconversionRate}}</p>
                                <p>日环比 {{index === 0 ? item.visitororderdaythan : item.visitorpaydaythan}}</p>
                                <p>周同比 {{index === 0 ? item.visitororderweekthane : item.visitorpayweekthan}}</p>
                            </div>
                        </div>
                        <div>
                            <p>
                                <span>商品访客数</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">{{item.tips}}</div>
                                    <img class="tooltip_icon" :src="toolTipsIcon" alt="">
                                </el-tooltip>
                            </p>
                            <p>{{item.visitclientsum}}</p>
                            <p>
                                <span>{{index === 0 ? '下单人数' : '付费用户数'}}</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">{{index === 0 ? item.tips1 : item.tips2}}</div>
                                    <img class="tooltip_icon" :src="toolTipsIcon" alt="">
                                </el-tooltip>
                            </p>
                            <p>{{index === 0 ? item.orderCreatesum : item.paycustomersum}}</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="payment_rate_box"">
                    <div>
                        <div>
                            <div>
                                <p>访客-支付转化率</p>
                                <p>- -</p>
                                <p>日环比 - -</p>
                                <p>周同比 - -</p>
                            </div>
                        </div>
                        <div>
                            <p>
                                <span>商品访客数</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">筛选时间内，所有商品页面的访问人数，同一访客多次访问会进行去重</div>
                                    <img class="tooltip_icon" :src="toolTipsIcon" alt="">
                                </el-tooltip>
                            </p>
                            <p>0</p>
                            <p>
                                <span>付费用户数</span>
                                <el-tooltip placement="top">
                                    <div class="tooltip_content" slot="content">筛选时间内，付款成功的用户数，一人多次付款记为一人（拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）</div>
                                    <img class="tooltip_icon" :src="toolTipsIcon" alt="">
                                </el-tooltip>
                            </p>
                            <p>0</p>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="title_box">
                <p>商品看板</p>
                <p @click="pageJump('Content')"><img :src="icon" alt="">商品分析</p>
            </div>
            <div class="content_goods_wrap3">
                <GoodsTable :goodsTableData="goodsTableData"></GoodsTable>
            </div>
            <div class="title_box">
                <p>用户看板</p>
                <p @click="pageJump('User')"><img :src="icon" alt="">用户分析</p>
            </div>
            <div class="content_user_wrap3">
                <Customer :shopUserData="shopUserData" :shopPayingUserData="shopPayingUserData"></Customer>
            </div>
        </div>
    </div>
</template>

<script>
import Echarts1 from 'views/dataCenter/dataTabs/echarts/Echarts1'
import Echarts2 from 'views/dataCenter/dataTabs/echarts/Echarts2'
import Echarts3 from 'views/dataCenter/dataTabs/echarts/Echarts3'
import GoodsTable from 'views/dataCenter/dataTabs/components/GoodsTable'
import Customer from 'views/dataCenter/dataTabs/components/Customer'
import {getIncomeBreakdownMap, getDataStatistics, getCoreIndicators, getTraffic, getConvert, getCommodity, getShopUser, getShopPayingUser} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'ProfileData',
    data() {
        return {
            activeIndex: '1',
            param: {
                shadowParam: 30,
                pieParam: 0,
                stripParam: 0,
                date: ''
            },
            icon: require('@/common/images/other/data_center_icon@2x.png'),
            toolTipsIcon: require('@/common/images/other/data_center_tools_icon@2x.png'),
            todayallmoney: '',
            yesterdayallmoney: '',
            incomeDatas: {}, // 实时数据echarts折线图数据
            // 实时数据 右边四个概况item
            realTimeData: [
                {
                    title: '访客数',
                    toolTipIcon: require('@/common/images/other/data_center_tools_icon@2x.png'),
                    tips: '0点截至当前时间，全店各页面的访问人数，同一访客多次访问会进行去重',
                    access: 0,
                    num: 0
                },
                {
                    title: '付费用户数',
                    toolTipIcon: require('@/common/images/other/data_center_tools_icon@2x.png'),
                    tips: '0点截至当前时间，付款成功的用户数，一人多次付款记为一人（拼团在成团时计入统计，问答在回答后计入统计，API导入订单不计入统计）',
                    access: 0,
                    num: 0
                },
                {
                    title: '浏览量',
                    toolTipIcon: require('@/common/images/other/data_center_tools_icon@2x.png'),
                    tips: '0点截至当前时间，店铺所有页面被访问的次数，一个人在统计时间内访问多次记为多次',
                    access: 0,
                    num: 0
                },
                {
                    title: '支付订单数',
                    toolTipIcon: require('@/common/images/other/data_center_tools_icon@2x.png'),
                    tips: '0点截至当前时间，成功付款的订单数（拼团在成团时计入统计，问答在回答后计入统计，API导入订单不计入统计）',
                    access: 0,
                    num: 0
                }
            ],
            // 核心指标 上边四个概况item
            coreData: {}, // 核心指标echarts折线图数据
            coreIndexData: [
                {
                    title: '付款金额',
                    data: 0.00,
                    day: 0,
                    week: 0,
                    tips: '筛选时间内，所有付款订单金额之和（拼团在成团时计入统计，问答在回答后计入统计，API导入订单不计入统计'
                },
                {
                    title: '访客数',
                    data: 0,
                    day: 0,
                    week: 0,
                    tips: '筛选时间内，全店各页面的访问人数，同一访客多次访问会进行去重'
                },
                {
                    title: '支付订单数',
                    data: 0,
                    day: 0,
                    week: 0,
                    tips: '筛选时间内，成功付款的订单数（拼团在成团时计入统计，问答在回答后计入统计，API导入订单不计入统计）'
                },
                {
                    title: '浏览量',
                    data: 0,
                    day: 0,
                    week: 0,
                    tips: '筛选时间内，店铺所有页面被访问的次数，一个人在统计时间内访问多次记为多次'
                }
            ],
            trafficEchartsData: {}, // 流量看板echarts折线图数据
            trafficData: [
                {
                    title: '浏览量',
                    conentviewsum: 0,
                    day: 0,
                    week: 0,
                    tips: '筛选时间内，店铺所有页面被访问的次数，一个人在统计时间内访问多次记为多次'
                },
                {
                    title: '访客数',
                    conentviewsum: 0,
                    day: 0,
                    week: 0,
                    tips: '筛选时间内，全店各页面的访问人数，同一访客多次访问会进行去重'
                }
            ],
            convertData: [], // 转化看板
            goodsTableData: {}, // 商品看板data
            shopUserData: [
                {},
                {cumulativeUsers: 0, cumulativeUsersdaythan: '0.00%', cumulativeUsersweekthan: '0.00%'},
                {newUsers: 0, newUsersdaythan: '0.00%', newUsersweekthan: '0.00%'},
                {activeUsers: 0, activeUsersdaythan: '0.00%', activeUsersweekthan: '0.00%'}
            ],
            shopPayingUserData: [
                {},
                {cumulativepayusers: 0, cumulativepayusersdaythan: '0.00%', cumulativepayusersweekthan: '0.00%'},
                {orderpaycustomer: 0, orderpaycustomerdaythan: '0.00%', orderpaycustomerweekthan: '0.00%'},
                {activePayingUser: 0, activepayinguserdaythan: '0.00%', activePayingUserweekthan: '0.00%'}
            ],
            options: [
                {
                    value: 0,
                    label: '自然天'
                }
            ],
            dayValue: 0,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                },
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24)
                            picker.$emit('pick', date)
                        }
                    },
                    {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', date)
                        }
                    }
                ]
            },
            dateValue: this.getDateTime(0)
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        profileData() {
            this.$router.push({name: 'ProfileData'})
        },
        traffic() {
            this.$router.push({name: 'Traffic'})
        },
        trading() {
            this.$router.push({name: 'Trading'})
        },
        content() {
            this.$router.push({name: 'Content'})
        },
        user() {
            this.$router.push({name: 'User'})
        },
        init() {
            this.getIncomeData()
            this.findDataStatistics()
            this.findCoreIndicators()
            this.findTrafficKanban()
            this.findConvert()
            this.fidCommodity()
            this.findShopUser()
            this.findShopPayingUser()
        },
        searchClick() {
            this.findCoreIndicators()
            this.findTrafficKanban()
            this.findConvert()
            this.fidCommodity()
            this.findShopUser()
            this.findShopPayingUser()
        },
        pageJump(value) {
            this.$router.push({name: value})
        },
        // 获取--实时概况(今日收入昨日收入)折线图数据
        getIncomeData() {
            this.setLoading(true)
            getIncomeBreakdownMap({
                success: data => {
                    this.setLoading(false)
                    this.incomeDatas = data.data
                    this.todayallmoney = data.data.todayallmoney
                    this.yesterdayallmoney = data.data.yesterdayallmoney
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--实时概况统计访客数 付费用户数 浏览量 支付订单数
        findDataStatistics() {
            this.setLoading(true)
            var params = {
                yesterday: this.getDateTime(0)
            }
            getDataStatistics({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.realTimeData[0].access = data.data.visitClientSum
                    this.realTimeData[0].num = data.data.yesterdayVisitClientCount
                    this.realTimeData[1].access = data.data.payCustomerSum
                    this.realTimeData[1].num = data.data.yesterdayPayCustomerCount
                    this.realTimeData[2].access = data.data.conentViewSum
                    this.realTimeData[2].num = data.data.yesterdayConentViewCount
                    this.realTimeData[3].access = data.data.orderPaySum
                    this.realTimeData[3].num = data.data.yesterdayOrderPayCount
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--运营视窗核心指标与指标趋势图
        findCoreIndicators() {
            this.setLoading(true)
            var params = {
                screenTime: this.dateValue === '' ? this.getDateTime(0) : this.dateValue
            }
            getCoreIndicators({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.coreData = data.data
                    this.coreIndexData[0].data = data.data.paymentamount
                    this.coreIndexData[0].day = data.data.paymentamountdaythan
                    this.coreIndexData[0].week = data.data.paymentamountweekthan
                    this.coreIndexData[1].data = data.data.visitclientsum
                    this.coreIndexData[1].day = data.data.visitclientdaythan
                    this.coreIndexData[1].week = data.data.visitclientweekthan
                    this.coreIndexData[2].data = data.data.orderpaysum
                    this.coreIndexData[2].day = data.data.orderpaydaythan
                    this.coreIndexData[2].week = data.data.orderpayweekthan
                    this.coreIndexData[3].data = data.data.conentViewSum
                    this.coreIndexData[3].day = data.data.conentviewdaythan
                    this.coreIndexData[3].week = data.data.conentviewweekthan
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--流量看板与流量趋势图
        findTrafficKanban() {
            this.setLoading(true)
            var params = {
                screenTime: this.dateValue === '' ? this.getDateTime(0) : this.dateValue
            }
            getTraffic({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.trafficEchartsData = data.data
                    this.trafficData[0].conentviewsum = data.data.conentviewsum
                    this.trafficData[0].day = data.data.conentviewdaythan
                    this.trafficData[0].week = data.data.conentviewweekthan
                    this.trafficData[1].conentviewsum = data.data.visitclientsum
                    this.trafficData[1].day = data.data.visitclientdaythan
                    this.trafficData[1].week = data.data.visitclientweekthan
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--转化看板
        findConvert() {
            this.setLoading(true)
            var params = {
                screenTime: this.dateValue === '' ? this.getDateTime(0) : this.dateValue
            }
            getConvert({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.convertData = data.data
                    this.convertData[0].title = '访客-下单转化率'
                    this.convertData[0].tips = '筛选时间内，所有商品页面的访问人数，同一访客多次访问会进行去重'
                    this.convertData[0].tips1 = '筛选时间内，点击了商品购买页面购买按钮的用户数'
                    this.convertData[1].title = '访客-支付转化率'
                    this.convertData[1].tips = '筛选时间内，所有商品页面的访问人数，同一访客多次访问会进行去重'
                    this.convertData[1].tips2 = '筛选时间内，付款成功的用户数，一人多次付款记为一人（拼团在成团时计入筛选，问答在回答后计入筛选，API导入订单不计入筛选）'
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--商品看板
        fidCommodity() {
            this.setLoading(true)
            var params = {
                screenTime: this.dateValue === '' ? this.getDateTime(0) : this.dateValue,
                datacount: 5
            }
            getCommodity({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.goodsTableData = data.data
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--用户看板--店铺用户数据
        findShopUser() {
            this.setLoading(true)
            var params = {
                screenTime: this.dateValue === '' ? this.getDateTime(0) : this.dateValue
            }
            getShopUser({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.shopUserData = data.data
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取--用户看板--店铺付费用户数据
        findShopPayingUser() {
            this.setLoading(true)
            var params = {
                screenTime: this.dateValue === '' ? this.getDateTime(0) : this.dateValue
            }
            getShopPayingUser({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.shopPayingUserData = data.data
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取昨日 日期
        getDateTime(type) {
            // type :  1--今天日期  0--昨天日期
            var time = null
            if (type === 1) {
                time = (new Date()).getTime()
            } else if (type === 0) {
                time = (new Date()).getTime() - 24 * 60 * 60 * 1000
            }
            var dateTime = new Date(time) // 获取的是前一天日期
            var year = dateTime.getFullYear()
            var month = dateTime.getMonth() + 1
            month = month < 10 ? '0' + month : month
            var day = dateTime.getDate()
            day = day < 10 ? '0' + day : day
            dateTime = year + '-' + month + '-' + day
            return dateTime
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Echarts1,
        Echarts2,
        Echarts3,
        GoodsTable,
        Customer
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ProfileData {
    .title_box{
        height: 50px;
        background-color: #F5F7FA;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px 0 15px;
        margin-bottom: 20px;
        p {
            height:16px;
            line-height:16px;
        }
        &>p:nth-of-type(1) {
            border-left: 2px solid #409EFF;
            padding-left: 10px;
        }
        &>p:nth-of-type(2) {
            color: #409EFF;
            display: flex;
            align-items: center;
            cursor: pointer;
            img{
                width: 16px;
                height: 14px;
                margin-right: 8px;
            }
        }
    }
    .padding-15 {
        padding: 15px;
    }
    .container_wrap1{
        .content_wrap1 {
            height: 420px;
            display: flex;
            .content_left_box {
                width: 60%;
                padding-right: 30px;
                .top_box{
                    color: #606266;
                    p{
                        display: flex;
                        align-items: center;
                        img{
                            width: 14px;
                            height: 14px;
                            cursor: pointer;
                        }
                    }
                    &>div{
                        display: flex;
                        justify-content: space-between;
                        margin: 15px 0 10px 0;
                        &>div {
                            width: auto;
                            p:nth-of-type(1){
                                font-size:12px;
                                line-height:17px;
                                height:17px;
                                // margin-bottom: 5px;
                            }
                            p:nth-of-type(2){
                                font-size: 22px;
                                height:30px;
                                line-height:30px;
                                font-weight:500;
                            }
                        }
                    }
                }
                .echarts_box{
                    // width: 720px;
                    width: 100%;
                    height: 320px;
                }
            }
            .content_right_box {
                width: 40%;
                padding: 30px 0;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .item_box{
                    box-sizing: border-box;
                    width: 48%;
                    padding: 20px;
                    color: #606266;
                    border: 1px solid #DCDFE6;
                    p:nth-of-type(1) {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        img{
                            width: 14px;
                            height: 14px;
                            cursor: pointer;
                        }
                    }
                    p:nth-of-type(2) {
                        font-size:28px;
                        height:40px;
                        line-height:40px;
                        margin: 10px 0 30px 0;
                    }
                    p:nth-of-type(3), p:nth-of-type(1) {
                        height: 20px;
                        line-height:20px;
                    }
                }
                .item_box:nth-of-type(1), .item_box:nth-of-type(2){
                    margin-bottom: 20px;
                }
            }
        }
    }
    .container_wrap2{
        color: #606266;
        .search_box{
            margin: 15px 0;
            display: flex;
            justify-content: space-between;
            .title_text{
                vertical-align: middle;
                height: 36px;
                line-height: 36px;
                font-size:16px;
            }
            .select_box{
                display: flex;
                justify-content: flex-end;
                .el-input, .el-select {
                    margin-right: 20px;
                }
                .el-input__inner {
                    height: 36px;
                }
                .el-input__icon {
                    line-height: 0;
                    height: 36px;
                }
                .el-button {
                    height: 36px;
                }
            }
        }
        .choose_content_wrap2{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            overflow: hidden;
            .choose_list{
                width: 100%;
                display: flex;
                .choose_list_item{
                    width: 25%;
                    border: 1px solid #DCDFE6;
                    border-right: none;
                    height: 158px;
                    padding: 20px;
                    box-sizing: border-box;
                    p{
                        height: 20px;
                        line-height: 20px;
                    }
                    p:nth-of-type(1){
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 2px;
                        img{
                            width: 14px;
                            height: 14px;
                            cursor: pointer;
                        }
                    }
                    p:nth-of-type(2){
                        height: 40px;
                        line-height: 40px;
                        font-size:28px;
                        font-weight:500;
                    }
                    p:nth-of-type(3){
                        margin: 6px 0 10px 0;
                    }
                }
                .choose_list_item:nth-of-type(1){
                    border-top: 4px solid #1989FA;
                }
                .choose_list_item:nth-of-type(2){
                    border-top: 4px solid #E6A23C;
                }
                .choose_list_item:nth-of-type(3){
                    border-top: 4px solid #67C23A;
                }
                .choose_list_item:nth-last-of-type(1){
                    border-top: 4px solid #F56C6C;
                    border-right: 1px solid #DCDFE6;
                }
            }
        }
        .echarts_wrap2{
            margin-top: 20px;
        }
    }
    .container_wrap3{
        margin-top: 24px;
        .content_wrap3{
            display: flex;
            margin-bottom: 20px;
            .echarts3 {
                width: 80%;
                height: 380px;
            }
            .content_right_box {
                width: 20%;
                margin-left: 46px;
                .item_box{
                    height: 158px;
                    box-sizing: border-box;
                    width: 100%;
                    padding: 20px;
                    color: #606266;
                    border: 1px solid #DCDFE6;
                    p:nth-of-type(1) {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        img{
                            width: 14px;
                            height: 14px;
                            cursor: pointer;
                        }
                    }
                    p:nth-of-type(2) {
                        font-size:28px;
                        height:40px;
                        line-height:40px;
                        margin: 10px 0 30px 0;
                    }
                    p:nth-of-type(3), p:nth-of-type(1) {
                        height: 20px;
                        line-height:20px;
                    }
                }
                .item_box:nth-of-type(1){
                    margin-bottom: 20px;
                }
            }
        }
        .content_traffic_wrap3{
            height: 320px;
            display: flex;
            margin-bottom: 20px;
            &>div{
                width: 50%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #606266;
            }
            .order_rate_box {
                &>div{
                    display: flex;
                    height: 210px;
                    overflow: hidden;
                    &>div:nth-of-type(1) {
                        box-sizing: border-box;
                        position: relative;
                        width: 280px;
                        height: 280px;
                        border: 6px solid #eee;
                        border-radius: 50%;
                        margin-right: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &>div{
                            margin-top: 46px;
                            p:nth-of-type(1) {
                                font-size: 16px;
                                font-weight: bold;
                            }
                            p:nth-of-type(2) {
                                text-align: center;
                                margin: 10px 0;
                                font-size: 16px;
                                font-weight: bold;
                            }
                            p:nth-of-type(3) {
                                margin-bottom: 10px;
                            }
                        }
                    }
                    &>div:nth-of-type(2) {
                        padding-top: 35px;
                        p:nth-of-type(2n+1) {
                            display: flex;
                            align-items: center;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-left: 10px;
                                cursor: pointer;
                            }
                        }
                        p:nth-of-type(2n) {
                            font-size:28px;
                            height:40px;
                            line-height:40px;
                            margin: 10px 0 20px 0;
                        }
                    }
                }
            }
        }
    }
    .content_goods_wrap3, .content_user_wrap3 {
        margin-bottom: 20px;
    }
}
</style>
<style scoped>
.tooltip_content {
    color: #606266;
    padding: 0 15px;
    line-height: 20px;
    width: 320px;
}
</style>